// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"Property_text-gradient__1GG57","property":"Property_property__2z1_e"};